import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"

const Body = () => {
  return (
    <section className="info-section my-3">
      <Container>
        <Row className="justify-content-center align-items-center">
          <Col lg={6} className="order-2 order-lg-1">
            <h1 className="my-4 my-lg-1">
              At <span className="green">LDA</span>
            </h1>
            <p>
              We have many years of experience dealing with small businesses,
              whether they are a one-person operation or a multi-location
              operation. We provide income tax, accounting and bookkeeping
              services to individual persons, small businesses and corporate
              clients. These services are specifically tailored to the unique
              needs of each client. At LDA, we treat our clients with courtesy
              and integrity. We guarantee an efficiency that achieves results.
              Our small team of professionals strive to relinquish any concerns,
              answer any questions, and successfully meet your income tax,
              accounting and bookkeeping needs.
            </p>
          </Col>
          <Col lg={6} className="order-1 order-lg-2">
            <StaticImage
              placeholder="tracedSVG"
              src="../assets/images/finance.svg"
              layout="constrained"
              alt="finance-img"
            />
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Body
